import type {CreateExtArgs, EnvironmentContext} from '@wix/document-manager-core'
import type {MatchImagesToPageParams} from '@wix/document-services-types'
import {generateAndInjectImages} from './utils'
import {fetchMatchingImages, type MatchImageToPageParams} from './requests'
import {ERRORS} from '../constants'

export const matchImagesToPage = async (
    {serverFacade}: Pick<EnvironmentContext, 'serverFacade'>,
    createExtArgs: CreateExtArgs,
    {componentPointers, siteDescription, userRequestInfo, onSuccess, onError}: MatchImagesToPageParams
): Promise<void> => {
    return generateAndInjectImages<MatchImageToPageParams>(
        createExtArgs,
        serverFacade,
        componentPointers,
        (_key, url, width, height) => ({
            width_RunwareFlux: width.toString(),
            height_RunwareFlux: height.toString(),
            userImage: url,
            Site_Description: siteDescription
        }),
        fetchMatchingImages,
        {
            userRequestInfo,
            onSuccess,
            onError,
            caller: 'matchImagesToPage',
            errorType: ERRORS.IMAGES.MATCH_IMAGES_TO_PAGE
        }
    )
}
